import styled from 'styled-components';

const OrganizerPageWrapper = styled.main`
  padding: 20px;

  .container {
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    width: 100%;
    box-sizing: border-box;

    .organizer-name {
      font-size: 24px;
    }

    .organizer-form-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .organizer-form-input {
      width: 100%;
      max-width: 250px;
      margin-bottom: 20px;
    }

    .organizer-form-button {
      max-width: 100px;
      padding: 10px;
      margin-top: 20px;
    }
  }
`;

export default OrganizerPageWrapper;
